import { LayoutRoute, Route } from "@soft-db/typed-router";

const spaceRoutes = new LayoutRoute({
	name: "spaces",
	path: "spaces",
	component: () => import("@/pages/spaces.vue"),
	children: [
		new Route({
			path: "",
			meta: {
				permission: "space.get",
				feature: "space",
			},
			component: () => import("@/pages/spaces/index.vue"),
		}),
		new Route({
			path: ":id",
			component: () => import("@/pages/spaces/_id/index.vue"),
			redirect: { name: "spaces-id-settings" },
			meta: {
				permission: ["user.update", "public-page.update"],
			},
			children: [
				new Route({
					path: "settings",
					component: () => import("@/pages/spaces/_id/settings.vue"),
				}),
				new Route({
					path: "users/:userid",
					meta: {
						permission: ["user.update"],
					},
					component: () => import("@/pages/spaces/_id/users/_userid.vue"),
				}),
				new Route({
					path: "public-pages/:pageid",
					meta: {
						permission: ["public-page.update"],
					},
					component: () => import("@/pages/spaces/_id/public/_pageid.vue"),
				}),
			],
		}),
	],
});

export default spaceRoutes;
